import { useMemo } from 'react';

type Action = 'view' | 'edit' | 'delete';
type MemberType = 'OWNER' | 'MEMBER' | 'ADMIN' | string;

const resolveModulePermissions = (roleData: any, entityId?: string) => {
  if (!roleData) return {};

  // if (roleData.accessLevel === 'RESTRICTED') {
  //   const matchedEntity = roleData?.restrictedEntities?.find((item: any) =>
  //     item.entityIds?.includes(entityId)
  //   );

  //   return (
  //     matchedEntity?.restrictedAccessModules ||
  //     roleData.restrictedAccessModules ||
  //     {}
  //   );
  // }

  switch (roleData.accessLevel) {
    case 'FULL':
      return roleData.fullAccessModules || {};
    case 'LIMITED':
      return roleData.limitedAccessModules || {};
    case 'RESTRICTED':
      return roleData?.restrictedAccessModules || {};
    default:
      return {};
  }
};

export const usePermissions = (
  roleData: any,
  memberType?: MemberType,
  entityId?: string,
) => {
  return useMemo(() => {
    const isOwner = memberType === 'OWNER';
    const isRestricted = roleData?.accessLevel === 'RESTRICTED';

    const matchedEntity = isRestricted
      ? roleData?.restrictedEntities?.find((item: any) =>
          item.entityIds?.includes(entityId),
        )
      : null;

    // console.log(matchedEntity, 'matchedEntity', roleData, isRestricted);

    const modules = resolveModulePermissions(roleData, entityId);

    const canModule = (moduleKey: string, action: Action) => {
      if (isOwner) return true;
      return Boolean(modules?.[moduleKey]?.[action]);
    };

    const canFinance = (moduleKey: string, action: Action) => {
      if (isOwner) return true;

      return Boolean(
        // isRestricted
        //   ? matchedEntity?.finance?.permissions?.[moduleKey]?.[action]
        //   :
        roleData?.finance?.permissions?.[moduleKey]?.[action],
      );
    };

    return {
      /* -------- META -------- */
      isOwner,
      memberType,
      allowToManageStudio: roleData?.allowToManageStudio,
      hideStore: roleData?.hideStore ?? false,
      accessLevel: roleData?.accessLevel,
      permissionType: roleData?.permissionType,

      /* -------- MODULE -------- */
      canView: (moduleKey: string) => canModule(moduleKey, 'view'),
      canEdit: (moduleKey: string) => canModule(moduleKey, 'edit'),
      canDelete: (moduleKey: string) => canModule(moduleKey, 'delete'),

      /* -------- FINANCE -------- */
      hasFinanceAccess: () =>
        isOwner ||
        roleData?.finance?.allowAccess ||
        roleData?.finance?.viewOnly,

      canFinance,

      canViewFinance: () =>
        isOwner ||
        roleData?.finance?.permissions?.allFinances?.view ||
        roleData?.finance?.permissions?.ownFinances?.view,

      /* -------- CHAT -------- */
      canChatLeadership: () => isOwner || roleData?.chat?.leadershipOnly,

      canChatDepartment: () => isOwner || roleData?.chat?.departmentOnly,

      canChatProductionOrStudio: () =>
        isOwner || roleData?.chat?.productionOrStudio,

      departmentId: roleData?.departmentId,
      isAddedFrom: roleData?.isAddedFrom,
    };
  }, [roleData, memberType, entityId]);
};
